import React from "react";
import styled from "styled-components";
import ToggleButton from "../../ui/ToggleButton/ToggleButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Props {
  title: string;
  labels?: any[];
  defaultLabelKey?: string;
  onLabelChange?: (selectedLabel: any) => void;
  averageScore?: number | string;
  thisSeason?: boolean;
}

const StyledCustomHeader = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  & .header-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
  }
  & .tabs-figure {
    display: inline-flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 24px;
  }
  & .score-text {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    font-family: DM Mono;
  }
  & .average-score {
    color: ${({ theme }) => theme.playerColor};
    text-align: right;
    font-feature-settings: "clig" off, "liga" off;
    font-family: DM Mono;
    font-size: 48px;
    font-style: normal;
    font-weight: 500;
    line-height: 48px; /* 100% */
    text-transform: uppercase;
    @media (max-width: 991px) {
      font-size: 50px;
    }
  }
  & .average-total {
    color: ${({ theme }) => theme.NumberColor};
    font-feature-settings: "clig" off, "liga" off;
    font-family: DM Mono;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 100% */
    font-color: "#7C7D79";
    text-transform: uppercase;
    margin-bottom: 10px;
  }
`;

const CustomHeader: React.FC<Props> = ({ title, labels, defaultLabelKey, onLabelChange, averageScore, thisSeason }) => {
  return (
    <StyledCustomHeader className="common-header align-items-end">
      <h3>{title}</h3>
      <div className="common-tab">
        {labels && defaultLabelKey && onLabelChange && (
          <ToggleButton labels={labels} defaultLabelKey={defaultLabelKey} onChange={onLabelChange} />
        )}
      </div>
      {averageScore && (
        <div className="score-text">
          <span className="average-score">{averageScore}</span>
        </div>
      )}
      {thisSeason && (
        <div className="common-header-drop common-header-right">
          This Season
          <KeyboardArrowDownIcon />
        </div>
      )}
    </StyledCustomHeader>
  );
};

export default CustomHeader;
